import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";

import FadeIn from "react-fade-in/lib/FadeIn";
import ProjectBlockMini from "./ProjectBlockMini";
import NavBuffer from "../projects/NavBuffer";
import Project from "./Project";
import { Link, Redirect, Route, useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
const BP = 768; // mobile breakpoint (px)
const isMobile = window.innerWidth <= BP;
// this takes in data from Projects
function ProjectsMini(props) {
  const location = useLocation();

  const getInitialProject = () => {
    if (!props.Class || !props.Class.projects) return null;
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    if (pathParts.length >= 3 && pathParts[0] === "projects") {
      const targetName = decodeURIComponent(pathParts[2]).trim().toLowerCase();
      return (
        props.Class.projects.find(
          (p) =>
            (p.name && p.name.trim().toLowerCase() === targetName) ||
            (p.id && p.id.trim().toLowerCase() === targetName)
        ) || null
      );
    }
    return null;
  };

  const [project, setProject] = useState(getInitialProject);
  const [routePath, setRoutePath] = useState(props.routePath);

  useEffect(() => {
    if (!props.Class || !props.Class.projects) return;
    const pathParts = location.pathname.split("/").filter(Boolean);
    if (pathParts.length >= 3 && pathParts[0] === "projects") {
      const targetName = decodeURIComponent(pathParts[2]).trim().toLowerCase();
      const matched = props.Class.projects.find(
        (p) =>
          (p.name && p.name.trim().toLowerCase() === targetName) ||
          (p.id && p.id.trim().toLowerCase() === targetName)
      );
      if (matched) {
        setProject(matched);
      }
    } else if (pathParts.length === 2 && pathParts[0] === "projects") {
      setProject(null);
    } else if (project && (project.id || project.name)) {
      const currentId = (project.id || project.name).trim().toLowerCase();
      const matched = props.Class.projects.find(
        (p) =>
          (p.id && p.id.trim().toLowerCase() === currentId) ||
          (p.name && p.name.trim().toLowerCase() === currentId)
      );
      if (matched) {
        setProject(matched);
      }
    }
  }, [location.pathname, props.Class]);

  const id = useRef(uuidv4()).current;

  const createProjectBlocks = (projects) => {
    const projectList = [];
    for (var i = 0; i < projects.length; i++) {
      const proj = projects[i];
      const projKey = proj.name || i;
      projectList.push(
        <Link key={projKey} to={`${props.routePath}/${proj.name}`}>
          <ProjectBlockMini
            dispId={props.dispId}
            func={(selectedProject) => {
              setProject(selectedProject);
              const el = document.getElementById(props.dispId);
              if (el) el.scrollTop = 0;
            }}
            index={i}
            project={proj}
          />
        </Link>
      );
    }
    return projectList;
  };
  const arraySplit = (array) => {
    return { leftArray: array, rightArray: [] };
  };

  useEffect(() => {
    console.log(props);
  }, []);

  return (
    <div>
      <Route exact path={[props.routePath, encodeURI(props.routePath)]}>
        <div
          id={id}
          onClick={() => {
            console.log("scrolling from project blocks mini");
            const el = document.getElementById(id);
            if (el) el.scrollTop = 0;
          }}
        >
          <div>
            {/* <FadeIn>
            <NavBuffer pad={80} transition={0.3}></NavBuffer>
          </FadeIn> */}
            <Title>{props.className}</Title>

            <Link style={{ textDecoration: "none" }} to={`/projects`}>
              <ClassTitle>
                <FadeIn delay={1000}>
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: "17px",
                      transform: "translate(10px,10px)",
                    }}
                  >
                    Back to projects
                  </div>
                </FadeIn>
              </ClassTitle>
            </Link>
            <DisplayAreaFull>
              <DisplayArea>
                <FadeIn delay={250}>
                  {createProjectBlocks(
                    arraySplit(props.Class.projects).leftArray
                  )}
                </FadeIn>
              </DisplayArea>
              {/* <Line></Line> */}
            </DisplayAreaFull>
          </div>
        </div>
      </Route>
      {project && (
        <Project
          navbar={props.navbar}
          project={project}
          func={() => {
            setProject(null);
          }}
        />
      )}
    </div>
  );
}

export default ProjectsMini;

const DisplayAreaFull = styled.div`
  margin-left: 4px;
  margin-right: 4px;
  display: flex;
  background-color: #f2f2f2;
  flex-direction: column;
  ::-webkit-scrollbar {
    display: none;
  }
`;

const DisplayArea = styled.div`
  width: 100%;
  height: 100%;
  padding-right: 4px;
  /* border-right: 3px solid white; */
`;
const Line = styled.div`
  position: fixed;
  left: 50%;
  transform: translate(-50%, -0px);
  height: 120%;
  border: 2px solid #f2f2f2;
  z-index: 1;
`;
const ClassTitle = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 70px;
  text-align: right;
  padding-right: 25px;
  font-size: 20px;
  color: #a6a6a6;

  font-weight: 600;
  line-height: 70px;
  cursor: pointer;
  z-index: 2;
  transition: 0.3s ease;
  &:hover {
    color: #595959;
  }
`;

const Title = styled.div`
  position: relative;
  height: ${isMobile ? "50px" : "80px"};
  width: 100%;
  line-height: ${isMobile ? "50px" : "80px"};
  font-size: ${isMobile ? "20px" : "30px"};
  color: #595959;
  text-align: center;
  font-weight: 600;
  background-color: #f2f2f2;
  z-index: 3;
  border-bottom: 3px solid #f2f2f2;
  cursor: default;
  transition: 0.4s ease;
`;
